<template>
    <template v-if="!['login'].includes($route.name)">
        <div id="wrap" class="has_left_menu" v-show="loaded">
            <header-component />
            <sidebar-component />
            <div id="content_wrap">
                <div :class="containerClass">
                    <router-view v-if="loaded"></router-view>
                </div>
            </div>
        </div>
    </template>
    <router-view v-else></router-view>
</template>

<script>
import HeaderComponent from './components/shared/HeaderComponent';
import SidebarComponent from './components/shared/SidebarComponent.vue';
import store from "@/store";
import {mapGetters} from "vuex";
import {ABILITY_TOKEN} from "@casl/vue";
import {AbilityBuilder, createMongoAbility} from "@casl/ability";

export default {
  inject: {
    ability: { from: ABILITY_TOKEN }
  },
    components: {HeaderComponent, SidebarComponent},
    name: 'App',
    data() {
        return {
          loaded: false,
        }
    },
    computed: {
        containerClass() {
            return this.$route.name === 'dashboard' ? 'container' : 'ticket_common_page';
        },
      ...mapGetters({
        permission: "auth/permissionList"
      })
    },
    async created() {
        await this.axios('/user')
            .then(({data}) => {
              this.$store.dispatch('auth/userInfo', data.data)
              store.dispatch('notification/getNotifications')
            })
            .catch(() => {
                this.$store.dispatch('auth/logout');
                this.$router.push({name: 'login'});
            })
            .finally(() => this.loaded = true)
      await store.dispatch('auth/getPermissions')

      const { can, rules } = new AbilityBuilder(createMongoAbility)
      can(this.permission)
      this.ability.update(rules)
    },
    mounted() {
      this.collapseArrow();

    }
}
</script>

<style>

</style>